import { render } from "./ReservationDetails.vue?vue&type=template&id=fd1b0ed6&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"

import "./ReservationDetails.vue?vue&type=style&index=0&id=fd1b0ed6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1b0ed6"]])

export default __exports__